var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasdelen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,34.7c-4.8.7-5.7.3-6.8-4.3-.8-3.4-2.6-6.5-3-10.2-.3-3.1-3.8-4.8-6.4-6.2-2.9-1.5-2.8-3.3-2.9-6.2C6.2,2.4,10.8,2.3,13.6,0c3.5,2.9,5.4,7.1,7.7,10.8,2.1,3.4,3.2,7.6,3.9,11.5.5,2.8,1,5.4,2.4,7.8,1.9,3.3,1.5,4-2.1,4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasdelen);
export default __webpack_public_path__ + "static/media/tasdelen.75f7291c7056dd316c2b66857da9dee9.svg";
export { ForwardRef as ReactComponent };